import React, { useState, useEffect } from "react";
import { GetNews } from "../../apis/api/NewsApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate ,useLocation} from "react-router-dom";
import Lodderr from "../../components/Lodder/Lodder";
import { formatDMY } from "../../utils/date";

const NewsPage = () => {
  const [newsData, setNewsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const newsPerPage = 8;
  const totalPages = Math.ceil(newsData?.length / newsPerPage);
  const navigate = useNavigate();

  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;
  const currentNews = newsData.slice(indexOfFirstNews, indexOfLastNews);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const prevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

  const dispatch = useDispatch();
  const location = useLocation();


  const { news } = useSelector((state) => state.NewsSlice);
  const { loading } = useSelector((state) => state.NewsSlice);

  useEffect(() => {
    dispatch(GetNews());
  }, [dispatch]);
  useEffect(() => {
    if (news) {
      setNewsData(news);
    }
  }, [news]);

  const handleRedirect = (news) => {
    navigate("/newsArticle", { state: { newsData: news ,from: location.pathname} });
  };
  return (
    <>
      {loading && <Lodderr />}
      <div className=""style={{ minHeight: "80vh", display: "flex", flexDirection: "column" }}>
        <div className="row">
          {currentNews.map((news) => (
            <div key={news.id} className="col-md-3 mb-4 d-flex ">
              <div
                className="card w-100 d-flex flex-column h-100vh shadow-sm transition"
                style={{
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.classList.add("shadow");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.classList.remove("shadow");
                }}
              >
                <div className="overflow-hidden" style={{ height: "180px" }}>
                  <img
                    src={(news.image) ? news.image.replace("/thumb", "") : 'assets/images/dummy-news-img.jpeg'}
                    className="card-img-top h-100 w-100 object-fit-cover"
                    alt={news.title}
                    loading="lazy"
                  />
                </div>
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title text-truncate">{news.title}</h5>
                  <p className="text-muted small mb-1">
                    <i className="bx bx-calendar"></i> {formatDMY(news.date)}
                  </p>
                  <p
                    className="card-text flex-grow-1 overflow-hidden"
                    style={{ maxHeight: "4.5em" }}
                  >
                    {news.description
                      .replace(/<\/?[^>]+(>|$)/g, "")
                      .slice(0, 150)}
                  </p>
                  <div className="text-center mt-auto">
                    <button
                      className="btn btn-dark btn-sm"
                      onClick={() => handleRedirect(news)}
                    >
                      <i className="bx bx-news"></i> Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      
      
      </div>
      <nav>
          <ul className="pagination justify-content-center">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button onClick={prevPage} className="page-link">
                Previous
              </button>
            </li>
            {Array.from({ length: totalPages }, (_, index) => (
              <li
                key={index}
                className={`page-item ${
                  currentPage === index + 1 ? "active" : ""
                }`}
              >
                <button
                  onClick={() => paginate(index + 1)}
                  className="page-link"
                >
                  {index + 1}
                </button>
              </li>
            ))}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button onClick={nextPage} className="page-link">
                Next
              </button>
            </li>
          </ul>
        </nav>
    </>
  );
};

export default NewsPage;
